import { useQuery } from "react-query";
import { request } from "../utils/axios-utils";

export const fetchAllStudios = (data) => {
  const [_blank, pageNum, pageSize] = data.queryKey;
  // || Or operator replace soon when all pagination done
  return request({
    url: `/studio/listingMinimal?pageNum=${pageNum || 1}&pageSize=${pageSize || 10}`,
    method: "GET",
  });
};

export const fetchListOfStudios = () => {
  return request({
    url: `/studio/listMinimal`,
    method: "GET",
  });
};

const useStudios = (onSuccess, select) => {
  return useQuery("studios", fetchAllStudios, {
    onSuccess: onSuccess ? onSuccess : null,
    retry: (failureCount, error) =>
      failureCount < 3 && error?.response?.status !== 401,
    select: select
      ? (data) => select(data.data.data)
      : (data) => data.data.data,
  });
};

export const useListingStudios = (onSuccess, select, onError) => {
  return useQuery("studios", fetchListOfStudios, {
    onSuccess: onSuccess ? onSuccess : null,
    retry: (failureCount, error) =>
      failureCount < 3 && error?.response?.status !== 401,
    onError: onError ? onError : null,
    select: select
      ? (data) => select(data.data.data)
      : (data) => data.data.data,
  });
};

export default useStudios;
